import * as React from 'react';
import { createApiClient } from '../../../services/ApiClient';
import { Modal, Button} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


interface StatusRequest {
    createTime: string;
    newStatusId: number;
    oldStatusId: number;
    user: string;
}

interface State {
    form: string;
    values: number;
    hsitory: Array<StatusRequest>;
    show: boolean;
}

const statusFormate = (cell) => {
    switch (cell) {
        case 0: return (<span className="label label-primary">Черновик</span>);
        case 1: return (<span className="label label-success">Одобрена</span>);
        case 2: return (<span className="label label-default">Отправлено</span>);
        case 3: return (<span className="label label-danger">Отклонена</span>);
        case 4: return (<span className="label label-default">Ожидание PDF</span>);
        case 5: return (<span className="label label-info" style={{whiteSpace:"pre-line"}}>Запрошены документы</span>);
        case 6: return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>На рассмотрении</span>);
        case 7: return (<span className="label label-success" style={{whiteSpace:"pre-line"}}>Документы отправлены</span>);
        case 8: return (<span className="label label-danger">Отозвана</span>);
        case 9: return (<span className="label label-warning" title="Дополнительный запрос">Дополнительный запрос</span>);

        case 12: return (<span className="label label-primary">Отчёт №1</span>)
        case 14: return (<span className="label label-primary">Отчёт №2</span>)
        case 13: return (<span className="label label-default">Ожидание PDF Отчёта №1</span>)
        case 15: return (<span className="label label-default">Ожидание PDF Отчёта №2</span>)
        case 16: return (<span className="label label-success">Отчёт №1 принят к сведению</span>)
        case 18: return (<span className="label label-success">Отчёт №2 принят к сведению</span>)
    }
}

class HistoryStatusModal extends React.Component<{}, State>{
    constructor() {
        super();
        this.state = {
            form: "",
            values: 0,
            hsitory: [],
            show: false
        }
        this.handleClose = this.handleClose.bind(this);
        this.onEnter = this.onEnter.bind(this);
    }

    handleClose() {
        this.setState({ show: false })
    }

    public show(form: string, values: number) {
        this.setState({
            form,
            values,
            show: true
        })
    }

    onEnter(){
        const client = createApiClient();
        const { form, values } = this.state;

        client.getHistory(form, values,{
            success: (data) =>{
                this.setState({ hsitory: data });
            }
        });
    }

    render() {
        const config ={
            height: '310px',
            options: {
                noDataText: 'У вас пока нет историй изменений статусов в заявке ',
            }
        }

        return (
            <Modal onEnter={this.onEnter} show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>История</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <BootstrapTable {...config} data={this.state.hsitory} >
                        <TableHeaderColumn dataField='id' isKey={true} hidden></TableHeaderColumn>
                        <TableHeaderColumn dataField='createTime'>Дата изменения</TableHeaderColumn>
                        <TableHeaderColumn dataField='oldStatusId' dataFormat={statusFormate}>Предыдущий статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='newStatusId' dataFormat={statusFormate} >Новый статус</TableHeaderColumn>
                        <TableHeaderColumn dataField='user' >Пользователь</TableHeaderColumn>
                   </BootstrapTable>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Закрыть</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default HistoryStatusModal;



// WEBPACK FOOTER //
// ./src/components/program/history/index.tsx